import createAxiosInstance from "../utils/apiUtils";

import { userBaseUrl } from "../constants/Constants";

// const IN_DEVELOPMENT = process.env.NODE_ENV === "development";

const instance = createAxiosInstance({
	baseURL: userBaseUrl + "/integrations/",
});

export const getDigitzsMerchant = async (dealerID, locationID) => {
	return await instance.get(`digitzs/merchant/${dealerID}/${locationID}`);
};

export const getDigitzsPayments = async (customerID) => {
	return await instance.get(`digitzs/payments/${customerID}`);
};

export const processDigitzsTransaction = async (body) => {
	return await instance.post(
		`digitzs/payment/process`,
		// `digitzs/test/payment/process`,
		body
	);
};

export const processDigitzsAchTransaction = async (body) => {
	return await instance.post(`digitzs/payment/process/ach`, body);
};

export const refundDigitzsTransaction = async (body) => {
	return await instance.post(
		`digitzs/payment/refund`,
		// `digitzs/test/payment/refund`,
		body
	);
};

// Gets transaction info from Digitzs
export const getDigitzsTransaction = async (id) => {
	return await instance.get(
		`digitzs/payment/${id}`
		// `digitzs/test/payment/${id}`
	);
};

// Gets all transaction info from Digitzs
export const getDigitzsMerchantTransactions = async (dealerID, locationID) => {
	return await instance.get(
		`digitzs/transactions/${dealerID}/${locationID}`
		// `digitzs/test/transactions/${dealerID}/${locationID}`
	);
};
